// import React, {forwardRef, useImperativeHandle, useRef} from 'react';
// import {Doughnut} from 'react-chartjs-2';
// import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js';
// import {PDFExport} from '@progress/kendo-react-pdf';
// import {dojahIcon, pdfBg} from 'assets/images/images';

// ChartJS.register(ArcElement, Tooltip, Legend);

// const AccountOverviewReport = forwardRef(({accountData = {}}, ref) => {
//   const pdfExportComponent = useRef(null);

//   useImperativeHandle(ref, () => ({
//     handleExportWithComponent: () => {
//       if (pdfExportComponent.current) {
//         pdfExportComponent.current.save();
//       }
//     },
//   }));

//   const eventsData = {
//     labels: ['Unflagged', 'Flagged'],
//     datasets: [
//       {
//         data: [50, 50],
//         backgroundColor: ['#55A249', '#B42318'],
//         borderWidth: 0,
//         borderRadius: 30,
//         spacing: 5,
//         rotation: -90,
//         circumference: 360,
//       },
//     ],
//   };

//   const casesData = {
//     labels: ['Allowed', 'Pending', 'Blocked'],
//     datasets: [
//       {
//         data: [10, 20, 15],
//         backgroundColor: ['#55A249', '#DC6803', '#B42318'],
//         borderWidth: 0,
//         borderRadius: 30,
//         spacing: 5,
//         rotation: -90,
//         circumference: 360,
//       },
//     ],
//   };

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     cutout: '75%',
//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         enabled: false,
//       },
//     },
//     hover: {
//       mode: null,
//     },
//     events: [],
//   };

//   const Header = () => (
//     <div
//       className=" "
//       style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginBottom: '10px',
//         fontSize: '12px',
//         zIndex: 1,
//       }}
//     >
//       <div style={{display: 'flex', alignItems: 'center'}}>
//         <img src={dojahIcon} alt="Dojah Logo" width={24} height={20} />
//       </div>
//       <div style={{textAlign: 'right'}}>
//         <div style={{color: '#4A4A68', fontStyle: 'italic'}}>
//           Generated by Dojah
//         </div>
//         <div style={{color: '#727272', fontStyle: 'italic'}}>
//           {new Date().toLocaleDateString('en-GB', {
//             day: '2-digit',
//             month: 'short',
//             year: 'numeric',
//           })}{' '}
//           {new Date().toLocaleTimeString('en-US', {
//             hour: 'numeric',
//             minute: '2-digit',
//             hour12: true,
//           })}
//         </div>
//       </div>
//     </div>
//   );

//   const pageContainerStyle = {
//     width: '100%',
//     padding: '17px 28px',
//     position: 'relative',
//     boxSizing: 'border-box',
//     display: 'flex',
//     flexDirection: 'column',
//     zIndex: 1,
//     backgroundImage: `url(${pdfBg})`,
//     backgroundRepeat: 'no-repeat',
//     backgroundPosition: 'center',
//     backgroundSize: 'contain',
//   };

//   return (
//     <div className="pdf-export-container   !bg-[#FFFFFF]">
//       <PDFExport
//         ref={pdfExportComponent}
//         paperSize="A4"
//         margin="40px"
//         fileName="Account_Overview_Report.pdf"
//         author="Dojah"
//         scale={0.8}
//       >
//         <div style={pageContainerStyle}>
//           <Header />

//           <div style={{marginBottom: '16px'}}>
//             <h1
//               style={{fontSize: '16px', fontWeight: '500', marginBottom: '4px'}}
//             >
//               Account Overview Report
//             </h1>
//             <p style={{fontSize: '12px', color: '#080917', fontWeight: '500'}}>
//               Date Range:{' '}
//               <span style={{color: '#727272'}}>
//                 {accountData.dateRange || '28/3/2025 - 30/3/2025'}
//               </span>
//             </p>
//           </div>

//           <div style={{marginBottom: '10px'}}>
//             <div
//               style={{
//                 fontSize: '10px',
//                 fontWeight: '500',
//                 padding: '4px',
//                 backgroundColor: '#ECECEC',
//                 marginBottom: '4px',
//               }}
//             >
//               User Details
//             </div>
//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse: 'collapse',
//                 fontSize: '10px',
//               }}
//             >
//               <tbody>
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Name
//                   </td>
//                   <td style={{width: '70%', padding: '4px'}}>Ayomide Oso</td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Email Address
//                   </td>
//                   <td style={{padding: '4px'}}>fraudguy@fruad.com</td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Risk Level
//                   </td>
//                   <td style={{width: '85%', padding: '4px'}}>
//                     <span
//                       style={{
//                         borderRadius: '25px',
//                         padding: '4px 8px',
//                         backgroundColor: '#B42318',
//                         color: 'white',
//                       }}
//                     >
//                       HIGH
//                     </span>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Risk Score
//                   </td>
//                   <td style={{width: '85%', padding: '4px'}}>
//                     <span
//                       style={{
//                         borderRadius: '25px',
//                         padding: '4px 8px',
//                         backgroundColor: '#DC6803',
//                         color: 'white',
//                       }}
//                     >
//                       40
//                     </span>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     First Seen Date
//                   </td>
//                   <td style={{width: '70%', padding: '4px'}}>Jan 13, 2024</td>
//                 </tr>{' '}
//                 <tr>
//                   <td
//                     style={{
//                       width: '15%',
//                       padding: '4px',
//                       backgroundColor: '#F5F5F5',
//                       color: '#868C98',
//                     }}
//                   >
//                     Last Seen Date
//                   </td>
//                   <td style={{width: '70%', padding: '4px'}}>Jan 13, 2024</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <div style={{marginBottom: '16px'}}>
//             <div
//               style={{
//                 fontSize: '10px',
//                 fontWeight: '500',
//                 padding: '4px',
//                 backgroundColor: '#ECECEC',
//                 marginBottom: '8px',
//               }}
//             >
//               Activity Summary
//             </div>

//             <div
//               style={{
//                 display: 'flex',
//                 flexDirection: 'row',
//                 justifyContent: 'space-between',
//                 marginBottom: '20px',
//                 flexWrap: 'wrap',
//                 gap: '14px',
//               }}
//             >
//               <div
//                 style={{
//                   flex: '1',
//                   minWidth: '250px',
//                   backgroundColor: '#F9F9F9',
//                   borderRadius: '6px',
//                   padding: '10px 12px 21px 12px',
//                 }}
//               >
//                 <h3
//                   style={{
//                     fontSize: '14px',
//                     fontWeight: '600',
//                     marginBottom: '10px',
//                     textAlign: 'left',
//                   }}
//                 >
//                   Events
//                 </h3>
//                 <div style={{display: 'flex', justifyContent: 'center'}}>
//                   <div
//                     style={{
//                       width: '200px',
//                       height: '200px',
//                       position: 'relative',
//                     }}
//                   >
//                     <Doughnut data={eventsData} options={chartOptions} />
//                     <div
//                       style={{
//                         position: 'absolute',
//                         top: '50%',
//                         left: '50%',
//                         transform: 'translate(-50%, -50%)',
//                         textAlign: 'center',
//                       }}
//                     >
//                       <div style={{fontSize: '16px', fontWeight: '500'}}>
//                         3,000
//                       </div>
//                       <div style={{fontSize: '10px', color: '#878787'}}>
//                         Total events
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div
//                   style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     flexDirection: 'column',
//                     gap: '10px',
//                     marginTop: '10px',
//                     flexWrap: 'wrap',
//                   }}
//                 >
//                   <div style={{display: 'flex', alignItems: 'center'}}>
//                     <div
//                       style={{
//                         width: '10px',
//                         height: '10px',
//                         backgroundColor: '#55A249',
//                         borderRadius: '50%',
//                         marginRight: '5px',
//                       }}
//                     ></div>
//                     <span style={{fontSize: '11px', color: '#4F555F'}}>
//                       50 Unflagged
//                     </span>
//                     <span
//                       style={{
//                         fontSize: '11px',
//                         color: '#B7BBC3',
//                         marginLeft: '4px',
//                       }}
//                     >
//                       (48%)
//                     </span>
//                   </div>
//                   <div
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                     }}
//                   >
//                     <div
//                       style={{
//                         width: '10px',
//                         height: '10px',
//                         backgroundColor: '#B42318',
//                         borderRadius: '50%',
//                         marginRight: '5px',
//                       }}
//                     ></div>
//                     <span style={{fontSize: '11px', color: '#4F555F'}}>
//                       50 Flagged
//                     </span>
//                     <span
//                       style={{
//                         fontSize: '11px',
//                         color: '#B7BBC3',
//                         marginLeft: '4px',
//                       }}
//                     >
//                       (50%)
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               <div
//                 style={{
//                   flex: '1',
//                   minWidth: '250px',
//                   backgroundColor: '#F9F9F9',
//                   borderRadius: '6px',
//                   padding: '10px 12px 21px 12px',
//                 }}
//               >
//                 <h3
//                   style={{
//                     fontSize: '14px',
//                     fontWeight: '600',
//                     marginBottom: '10px',
//                     textAlign: 'left',
//                   }}
//                 >
//                   Cases
//                 </h3>
//                 <div style={{display: 'flex', justifyContent: 'center'}}>
//                   <div
//                     style={{
//                       width: '200px',
//                       height: '200px',
//                       position: 'relative',
//                     }}
//                   >
//                     <Doughnut data={casesData} options={chartOptions} />
//                     <div
//                       style={{
//                         position: 'absolute',
//                         top: '50%',
//                         left: '50%',
//                         transform: 'translate(-50%, -50%)',
//                         textAlign: 'center',
//                       }}
//                     >
//                       <div style={{fontSize: '16px', fontWeight: '500'}}>
//                         200
//                       </div>
//                       <div style={{fontSize: '10px', color: '#878787'}}>
//                         Total cases
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div
//                   style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     gap: '10px',
//                     marginTop: '10px',
//                     flexWrap: 'wrap',
//                   }}
//                 >
//                   <div style={{display: 'flex', alignItems: 'center'}}>
//                     <div
//                       style={{
//                         width: '10px',
//                         height: '10px',
//                         backgroundColor: '#55A249',
//                         borderRadius: '50%',
//                         marginRight: '5px',
//                       }}
//                     ></div>
//                     <span style={{fontSize: '11px', color: '#4F555F'}}>
//                       10 Allowed
//                     </span>
//                     <span
//                       style={{
//                         fontSize: '11px',
//                         color: '#B7BBC3',
//                         marginLeft: '4px',
//                       }}
//                     >
//                       (48%)
//                     </span>
//                   </div>
//                   <div style={{display: 'flex', alignItems: 'center'}}>
//                     <div
//                       style={{
//                         width: '10px',
//                         height: '10px',
//                         backgroundColor: '#DC6803',
//                         borderRadius: '50%',
//                         marginRight: '5px',
//                       }}
//                     ></div>
//                     <span style={{fontSize: '11px', color: '#4F555F'}}>
//                       20 Pending
//                     </span>
//                     <span
//                       style={{
//                         fontSize: '11px',
//                         color: '#B7BBC3',
//                         marginLeft: '4px',
//                       }}
//                     >
//                       (48%)
//                     </span>
//                   </div>
//                 </div>
//                 <div
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     marginTop: '10px',
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: '10px',
//                       height: '10px',
//                       backgroundColor: '#B42318',
//                       borderRadius: '50%',
//                       marginRight: '5px',
//                     }}
//                   ></div>
//                   <span style={{fontSize: '11px', color: '#4F555F'}}>
//                     15 Blocked
//                   </span>
//                   <span
//                     style={{
//                       fontSize: '11px',
//                       color: '#B7BBC3',
//                       marginLeft: '4px',
//                     }}
//                   >
//                     (50%)
//                   </span>
//                 </div>
//               </div>
//             </div>

//             <div
//               style={{
//                 fontSize: '10px',
//                 fontWeight: '500',
//                 padding: '4px',
//                 backgroundColor: '#ECECEC',
//                 marginBottom: '4px',
//               }}
//             >
//               Event Breakdown
//             </div>
//             <div
//               style={{
//                 marginTop: '8px',
//                 backgroundColor: '#F9F9F9',
//                 padding: '12px 15px 21px 12px',
//                 borderRadius: '6px',
//               }}
//             >
//               <h3
//                 style={{
//                   fontSize: '10px',
//                   fontWeight: '600',
//                   color: '#080808',
//                   marginBottom: '10px',
//                 }}
//               >
//                 Transaction Type
//               </h3>

//               <div
//                 style={{
//                   display: 'grid',
//                   gridTemplateColumns: '1fr 1fr',
//                   gap: '20px',
//                   marginBottom: '16px',
//                 }}
//               >
//                 <div
//                   style={{
//                     borderRadius: '6px',
//                     backgroundColor: 'white',
//                     padding: '5px 10px',
//                   }}
//                 >
//                   <h4
//                     style={{
//                       fontWeight: '500',
//                       marginBottom: '5px',
//                       fontSize: '10px',
//                       color: '#396C31',
//                     }}
//                   >
//                     Credit
//                   </h4>
//                   <p style={{fontSize: '10px', marginBottom: '9px'}}>
//                     500 events
//                   </p>
//                   <p style={{fontSize: '10px'}}>NGN 300,000</p>
//                 </div>
//                 <div
//                   style={{
//                     borderRadius: '6px',
//                     backgroundColor: 'white',
//                     padding: '5px 10px',
//                   }}
//                 >
//                   <h4
//                     style={{
//                       fontWeight: '500',
//                       marginBottom: '5px',
//                       fontSize: '10px',
//                       color: '#B42318',
//                     }}
//                   >
//                     Debit
//                   </h4>
//                   <p style={{fontSize: '10px', marginBottom: '9px'}}>
//                     500 events
//                   </p>
//                   <p style={{fontSize: '10px'}}>NGN 300,000</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </PDFExport>
//     </div>
//   );
// });

// AccountOverviewReport.displayName = 'AccountOverviewReport';

// export default AccountOverviewReport;

import React from 'react';

function AccountOverviewReport() {
  return <div></div>;
}

export default AccountOverviewReport;
